import React from 'react';

const actions = {
  SET_DATES: 'SET_DATES',
  SET_ROOM_DETAILS: 'SET_ROOM_DETAILS',
  SET_GUEST_DETAILS: 'SET_GUEST_DETAILS',
  RESET_FORM: 'RESET_FORM',
  RESET_FORM_ROOMS: 'RESET_FORM_ROOMS',
};

const initialFormState = {
  bookingDates: null,
  roomsDetails: null,
  guestsDetails: null,
};

const actionHandlers = {
  [actions.SET_DATES]: (state, payload) => ({ ...state, bookingDates: payload }),
  [actions.SET_ROOM_DETAILS]: (state, payload) => ({ ...state, roomsDetails: payload }),
  [actions.SET_GUEST_DETAILS]: (state, payload) => ({ ...state, guestsDetails: payload }),
  [actions.RESET_FORM]: () => initialFormState,
  [actions.RESET_FORM_ROOMS]: state => ({ ...state, roomsDetails: null }),
};

const createBookingFormReducer = (state, action) => {
  const handler = actionHandlers[action.type];
  if (!handler) {
    throw new Error(`Unknown action type: ${action.type}`);
  }
  return handler(state, action.payload);
};

const CreateBookingFormContext = React.createContext({});
export {
  CreateBookingFormContext,
  createBookingFormReducer,
  initialFormState,
  actions as formActions,
};
